import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { API, AreaCategoryDTO, CompanyDTO } from 'src/app/services/api/api';
import { UtilService } from 'src/app/services/util.service';
import { ErrorService } from 'src/app/services/error.service';
import { PermissionService } from '../../../services/permission.service';
import { MsOptions } from '../../../services/global/global-interfaces';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { CompaniesComponent } from '../../company/companies/companies.component';
import { ModalService } from '../../../services/gui/modal/modal.service';

@Component({
  selector: 'sb-page-area-category-edit',
  templateUrl: './area-category-edit.component.html',
  styleUrls: ['./area-category-edit.component.scss'],
  standalone: false,
})
export class AreaCategoryEditComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  @Input() category: AreaCategoryDTO;
  @Input() company: CompanyDTO;
  @Output() saveClick: EventEmitter<boolean> = new EventEmitter();

  areaCategories: AreaCategoryDTO[] = [];
  msCategoryOptions: MsOptions;
  isCompanyDisabled: boolean = false;

  constructor(
    private api: API,
    public util: UtilService,
    private errorHandler: ErrorService,
    public permissionService: PermissionService,
    private readonly modalService: ModalService,
    protected readonly modalNavigationService: ModalNavigationService
  ) {}

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.category = this.modalNavigationService.getCurrentNavigation().data.cullCategory;
      this.company = this.modalNavigationService.getCurrentNavigation().data.company;
    }
    if (this.company) {
      this.isCompanyDisabled = true;
    }
  }

  selectCompany() {
    if (this.isInModalContext) {
      return;
    }
    this.modalService
      .showNavigationModal({
        entryComponent: { value: CompaniesComponent, data: {} },
        title: null,
        modalOptions: { windowClass: 'bigXL' },
      })
      .then((result: CompanyDTO) => {
        if (result) {
          this.category.company = result;
        } else {
          this.category.company = null;
        }
      })
      .catch(() => {});
  }

  msRequest(type: string, options?: MsOptions) {
    if (type === 'AREA_CATEGORIES') {
      if (options) {
        this.msCategoryOptions = options;
      }
      if (this.msCategoryOptions?.pagination) {
        this.api
          .ca_md_AreaCategory_retrieveAll(
            {
              search: this.util.encodeSearchQueryParam(false, this.msCategoryOptions?.search),
              company: this.category?.company?.id ?? null,
              notInHierarchyOf: this.category?.id ?? null,
            },
            this.msCategoryOptions?.pagination
          )
          .subscribe({
            next: (categories: AreaCategoryDTO[]) => {
              this.areaCategories = categories;
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
      }
    }
  }

  update($event: any[], type: string) {
    if (type === 'AREA_CATEGORIES') {
      if ($event && $event.length > 0) {
        this.category.parent = $event[0];
      } else {
        this.category.parent = null;
      }
    }
  }
}
